module.exports = __webpack_public_path__ + "media/images/pikabu-58ce6ad2cd7ca1fc5871e5d0fb15cd63.png";